import React from 'react'
import PropTypes from 'prop-types'
import {
    Drawer,
    DrawerOverlay,
    DrawerContent,
    DrawerHeader,
    DrawerBody,
    Text,
    useBreakpointValue,
    Button,
    Icon,
    IconButton,
    useStyleConfig
} from '@chakra-ui/react'
import {FormattedMessage, useIntl} from 'react-intl'
import { getCountryName } from '../../utils/utils'
import {CustomClose} from '../icons'
import {useBrand} from '../../contexts/brand-context'

const CountrySelectorConfirmationDrawer = ({
    isOpen,
    onClose,
    fromCountry,
    toCountry,
    onConfirmation
}) => {
    const intl = useIntl()
    const {isGarage} = useBrand()
    const drawerPlacement = useBreakpointValue({ base: 'bottom', md: 'right' });
    const styles = useStyleConfig('CountrySelectorConfirmation')

    const handleYes = () => {
        onConfirmation('yes')
        onClose()
    }

    const handleNo = () => {
        onConfirmation('no')
        onClose()
    }

    return (
        <Drawer isOpen={isOpen} onClose={handleNo} size="sm" placement={drawerPlacement}>
            <DrawerOverlay />
            <DrawerContent>
                <DrawerHeader {...styles.header}>
                    <Text {...styles.headerTitle}>
                        <FormattedMessage
                            id="country_selector_drawer.title"
                            defaultMessage="Confirm Shipping Country"
                        />
                    </Text>
                    <IconButton
                        onClick={handleNo}
                        icon={<Icon as={CustomClose} />}
                        aria-label={intl.formatMessage({
                            id: 'header.button.close.modal',
                            defaultMessage: 'Close modal'
                        })}
                        {...styles.closeButton}
                        variant="ghost"
                        size="sm"
                    />
                </DrawerHeader>
                <DrawerBody {...styles.body}>
                    <Text {...styles.message}>
                        {isGarage ? (
                            <FormattedMessage
                                id="country_selector_drawer.message_garage"
                                defaultMessage="You are currently shopping on {country} website. When changing countries your shopping bag will be emptied. Are you sure you want to proceed?"
                                values={{
                                    country: getCountryName(fromCountry)
                                }}
                            />
                        ) : (
                            <FormattedMessage
                                id="country_selector_drawer.message_dynamite"
                                defaultMessage="You are currently shopping on {country} website. When changing countries your shopping bag will be emptied. Are you sure you want to proceed?"
                                values={{
                                    country: getCountryName(fromCountry)
                                }}
                            />
                        )}
                    </Text>
                    <Button
                        variant={'webPrimary'}
                        data-testid="country-confirm-yes-button"
                        onClick={handleYes}
                        {...styles.cta}
                    >
                        <FormattedMessage
                            id="country_selector_drawer_cta.continue_to"
                            defaultMessage="Yes, continue to {country}"
                            values={{
                                country: getCountryName(toCountry)
                            }}
                        />
                    </Button>
                    <Button
                        data-testid="country-confirm-no-button"
                        onClick={handleNo}
                        variant={'webSecondaryOutline'}
                        {...styles.cta}
                    >
                        <FormattedMessage
                            id="country_selector_drawer_cta.return_to"
                            defaultMessage="No, return to {country}"
                            values={{
                                country: getCountryName(fromCountry)
                            }}
                        />
                    </Button>
                </DrawerBody>
            </DrawerContent>
        </Drawer>
    )
}

CountrySelectorConfirmationDrawer.propTypes = {
    isOpen: PropTypes.bool,
    onClose: PropTypes.func,
    fromCountry: PropTypes.string,
    toCountry: PropTypes.string,
    onConfirmation: PropTypes.func,
}

export default CountrySelectorConfirmationDrawer
